
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class DismantlingBOMGrid extends Serenity.EntityGrid<DismantlingBOMRow, any> {
        protected getColumnsKey() { return 'Production.DismantlingBOM'; }
        protected getDialogType() { return DismantlingBOMDialog; }
        protected getIdProperty() { return DismantlingBOMRow.idProperty; }
        protected getInsertPermission() { return DismantlingBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return DismantlingBOMRow.localTextPrefix; }
        protected getService() { return DismantlingBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}